import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { ClosingCta } from '#src/app/pages/about/shared/components';

export const VisionCta: React.FC<EmptyProps> = () => {
	return (
		<ClosingCta
			heading={translationKey('corgi.vision_page.cta.heading')}
			body={translationKey('corgi.vision_page.cta.body')}
			primary={{
				href: '/start-a-petition/intro',
				label: translationKey('corgi.vision_page.cta.start_petition'),
				dataQa: 'vision-cta-start-petition',
			}}
			secondary={{
				href: '/about',
				label: translationKey('corgi.vision_page.cta.about'),
				dataQa: 'vision-cta-about',
			}}
		/>
	);
};
